import type { UseMutationOptions } from "@tanstack/react-query";
import type {
	ActionInput,
	ActionName,
	ActionOutput,
} from "@/setup/backend/types";

import { actionFetch } from "./actionFetch";
import type { ActionFetchFn } from "./ApiFetchContext";

export function getActionMutationOptions<A extends ActionName>(
	name: A,
	opts: {
		parseOnly?: boolean;
		batchEnabled?: boolean;
		actionFetchOverride?: ActionFetchFn;
	} = {},
) {
	const fetchFn = opts.actionFetchOverride ?? actionFetch;
	return {
		mutationFn: (input) => {
			return fetchFn(name, input, opts.batchEnabled, opts.parseOnly);
		},
	} as UseMutationOptions<ActionOutput<A>, any, ActionInput<A>>;
}
